import { useLocation, useNavigate } from "react-router-dom";
import Button from "../atoms/buttons/Button";
import SuccessImage from "../../assets/Images/BrandSignupSuccess.svg";
import { ROUTES } from "../../constants";

function BrandSubmissionSuccessForm() {
  const navigate = useNavigate();
  const { state } = useLocation();

  // @ts-ignore
  if (state?.reload) {
    window.history.replaceState(null, "");
    window.location.reload();
  }

  return (
    <div className="my-10 grid grid-cols-12 gap-y-4">
      <div className="col-span-12 flex  justify-center font-sora text-6xl font-bold text-white">
        Thank you for signing up!
      </div>
      <div className="col-span-12 text-center font-satoshi  text-sm font-semibold  leading-7 text-white">
        We have received your request to join as a Brand.
        <br />
        Our team will contact you soon to onboard you to the MAGNETIQ platform. Cheers!
      </div>
      <div className="col-span-12 flex justify-center">
        <img src={SuccessImage} alt="success" />
      </div>
      <div className="col-span-12 flex justify-center font-satoshi  text-sm font-semibold leading-7 text-white">
        <div>Meanwhile, you can visit below pages:</div>
      </div>
      <div className="col-span-12  flex justify-center  gap-x-5 font-sora">
        <Button
          additionalClasses="xl:text-xs
          2xl:text-sm xl:px-8 xl:py-3 2xl:px-10 2xl:py-4"
          text="DISCOVER"
          variant="rustPinkSolid"
          onClick={() => navigate(ROUTES.BRANDS_DISCOVER)}
        />
        <Button
          additionalClasses="xl:text-xs
          2xl:text-sm xl:px-8 xl:py-3 2xl:px-10 2xl:py-4"
          text="MY FRIDGE"
          variant="whiteSolid"
          onClick={() => navigate(ROUTES.USER_PROFILE_PAGE)}
        />
      </div>
    </div>
  );
}
export default BrandSubmissionSuccessForm;
